import { ClickAction } from './click-action.model';
import { ExternalLink } from './external-link.model';
import { SinglePageCards } from '@cart-checkout/checkout/data-access/enums';

export class AlertMessage {
	public message: string;
	public messageLocation: SinglePageCards;
	public clickAction: ClickAction;
	public externalLink: ExternalLink;

	constructor(message: string, clickAction: ClickAction, externalLink: ExternalLink, messageLocation?: SinglePageCards) {
		this.message = message;
		this.clickAction = clickAction;
		this.externalLink = externalLink;
		this.messageLocation = messageLocation;
	}
}
